export default __webpack_public_path__ + "static/media/success-mobile.6ae35f47.svg";